import React, { useEffect, createElement } from 'react';
import { Check, Music, BookOpen, Clock, Shield, Star, Menu, X, ChevronDown, Download, Gift } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function LandingPage() {
  // Meta Pixel Integration
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1266222218891306');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1266222218891306&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
    return () => {
      // Cleanup if needed, though usually pixel stays for the session
    };
  }, []);
  const features = ['Entender la música paso a paso', 'Participar más', 'Disfrutar las clases', 'Mejorar presentaciones y actos', 'Aprender jugando', 'Sentirse seguros'];
  const teacherBenefits = ['Ahorrar horas TODAS las semanas', 'Dejar de improvisar', 'Tener respaldo profesional', 'Cubrir todo el programa', 'Dar clases más dinámicas', 'Volver a disfrutar enseñar'];
  const faqs = [{
    question: '¿El material es digital o físico?',
    answer: 'Todo el contenido es 100% digital. Lo recibís por descarga inmediata y podés usarlo desde la compu, celular o tablet. Podés imprimir lo que necesites para trabajar en el aula.'
  }, {
    question: '¿Cómo recibo el MegaPack?',
    answer: 'Apenas se confirma tu compra, recibís el acceso inmediato para descargar todo el material. No esperás envíos ni dependés de nadie.'
  }, {
    question: '¿Sirve para todos los niveles?',
    answer: 'Sí. Incluye material organizado para: Maternal, Preescolar, Inicial, Primaria y Secundaria (1° a 6°). Todo separado por nivel y listo para usar.'
  }, {
    question: '¿Necesito experiencia previa?',
    answer: 'No. El MegaPack está pensado para que puedas usarlo aunque estés empezando. Las guías te explican cómo aplicar cada recurso paso a paso.'
  }, {
    question: '¿Puedo usarlo en clases presenciales y virtuales?',
    answer: 'Sí. Podés usar el material tanto en clases presenciales como en clases online, presentaciones, actos, talleres y proyectos especiales.'
  }, {
    question: '¿Cuánto tiempo tengo acceso?',
    answer: 'Tu acceso es ilimitado y de por vida. Lo descargás una vez y es tuyo para siempre.'
  }, {
    question: '¿Es seguro comprar en esta página?',
    answer: 'Sí. El pago está protegido con plataformas de cobro seguras y encriptadas. Tus datos están completamente protegidos.'
  }, {
    question: '¿Qué pasa si no me gusta o no me sirve?',
    answer: 'Tenés 7 días de garantía. Si sentís que no es para vos, nos escribís y te devolvemos el 100% de tu dinero. Sin vueltas. Sin letra chica.'
  }];
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900" data-id="element-26">
      <PurchaseNotification data-id="element-27" />

      {/* Announcement Bar */}
      <div className="bg-blue-900 text-white text-center py-2 px-4 text-sm font-medium" data-id="element-28">
        🔥 OFERTA LIMITADA: 70% DE DESCUENTO HOY
      </div>

      {/* Hero Section */}
      <header className="bg-white pb-8 pt-6 px-4 md:px-8 lg:px-16 overflow-hidden" data-id="element-29">
        <div className="max-w-4xl mx-auto text-center" data-id="element-30">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-blue-900 mb-3 tracking-tight leading-tight" data-id="element-31">
            🎶 MEGAPACK MÚSICA LISTA™
          </h1>
          <p className="text-xl md:text-2xl text-orange-600 font-bold mb-4" data-id="element-32">
            Todo tu año de Música resuelto.
          </p>

          <div className="relative mx-auto max-w-[260px] md:max-w-[340px] mb-4 transform hover:scale-105 transition-transform duration-500" data-id="element-33">
            <div className="absolute inset-0 bg-blue-500 rounded-full blur-3xl opacity-20 animate-pulse" data-id="element-34"></div>
            <img src="https://cdn.magicpatterns.com/uploads/5AHTgg8bxWwbEujLWhwGXz/PROYECTOS_Anuales_(1).png" alt="Megapack Música Lista Producto Principal" className="relative z-10 w-full drop-shadow-2xl" data-id="element-35" />
          </div>

          <div className="space-y-3 mb-6" data-id="element-36">
            <p className="text-lg md:text-xl text-gray-700 font-medium" data-id="element-37">
              Sin improvisar. Sin perder horas. Sin estrés.
            </p>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-38">
              El sistema definitivo de material musical listo para usar en todos
              los niveles educativos.
            </p>
          </div>

          <CTAButton size="large" className="animate-bounce-subtle" data-id="element-39">
            SI, QUIERO EL MEGAPACK MÚSICA LISTA™
          </CTAButton>

          <p className="mt-3 text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-40">
            <Shield className="w-4 h-4" data-id="element-41" /> Garantía de satisfacción de 7 días
          </p>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-gray-100" data-id="element-42">
        <div className="max-w-3xl mx-auto" data-id="element-43">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8" data-id="element-44">
            Si sos docente de Música, esto te va a sonar muy familiar…
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-orange-500 space-y-6" data-id="element-45">
            <p className="text-lg text-gray-700" data-id="element-46">Llegás a tu casa cansado/a…</p>
            <p className="text-lg text-gray-700" data-id="element-47">
              Sabés que tenés que planificar…
            </p>
            <p className="text-lg text-gray-700" data-id="element-48">Abrís la compu…</p>
            <p className="text-lg font-bold text-gray-900" data-id="element-49">
              Y empezás otra vez de cero.
            </p>
            <p className="text-gray-600 italic" data-id="element-50">
              Buscando partituras. Buscando canciones. Buscando ideas. Buscando
              actividades que "funcionen".
            </p>
          </div>

          <div className="mt-12 text-center" data-id="element-51">
            <p className="text-xl text-gray-800 mb-6" data-id="element-52">
              Y el tiempo vuela. Y el cansancio crece. Y tu cabeza no para.
            </p>
            <p className="text-lg text-gray-600 mb-8" data-id="element-53">
              No porque no sepas enseñar. No porque no seas buen/a docente.
            </p>
            <div className="bg-blue-50 p-6 rounded-xl inline-block" data-id="element-54">
              <p className="text-xl font-bold text-blue-800" data-id="element-55">
                👉 Sino porque estás intentando sostener todo el año sin un
                sistema que te sostenga a vos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* The Real Problem */}
      <section className="py-16 px-4 bg-white" data-id="element-56">
        <div className="max-w-4xl mx-auto text-center" data-id="element-57">
          <h2 className="text-3xl font-bold text-red-600 mb-8" data-id="element-58">
            El problema real
          </h2>
          <p className="text-xl text-gray-700 mb-8" data-id="element-59">
            El sistema educativo hoy te exige:
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-60">
            {['planificar', 'crear material', 'motivar alumnos', 'cubrir contenidos', 'preparar actos', 'armar proyectos', 'cumplir programas'].map(item => <span key={item} className="bg-red-50 text-red-700 px-4 py-2 rounded-full font-medium border border-red-100" data-id="element-61">
                • {item}
              </span>)}
          </div>

          <p className="text-xl font-medium text-gray-800 mb-8" data-id="element-62">
            …todo al mismo tiempo.
          </p>
          <p className="text-lg text-gray-600 mb-10" data-id="element-63">
            Y nadie te dio un sistema que te ahorre ese trabajo.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto" data-id="element-64">
            <div className="bg-gray-50 p-4 rounded-lg flex items-center gap-3" data-id="element-65">
              <X className="text-red-500 w-6 h-6 flex-shrink-0" data-id="element-66" />
              <span className="text-gray-700 font-medium" data-id="element-67">
                Vivís improvisando
              </span>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg flex items-center gap-3" data-id="element-68">
              <X className="text-red-500 w-6 h-6 flex-shrink-0" data-id="element-69" />
              <span className="text-gray-700 font-medium" data-id="element-70">
                Llevando trabajo a casa
              </span>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg flex items-center gap-3" data-id="element-71">
              <X className="text-red-500 w-6 h-6 flex-shrink-0" data-id="element-72" />
              <span className="text-gray-700 font-medium" data-id="element-73">
                Sintiendo que nunca terminás
              </span>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg flex items-center gap-3" data-id="element-74">
              <X className="text-red-500 w-6 h-6 flex-shrink-0" data-id="element-75" />
              <span className="text-gray-700 font-medium" data-id="element-76">
                Agotado/a antes de mitad de año
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution */}
      <section className="py-20 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-77">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/musical.png')]" data-id="element-78"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-79">
          <span className="inline-block bg-orange-500 text-white px-4 py-1 rounded-full text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-80">
            La Solución Definitiva
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6" data-id="element-81">
            🎼 MEGAPACK MÚSICA LISTA™
          </h2>
          <p className="text-xl md:text-2xl text-blue-100 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-82">
            Un sistema completo de materiales musicales organizados por nivel
            para que nunca más tengas que empezar de cero.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center mb-12" data-id="element-83">
            <div className="bg-blue-800/50 p-4 rounded-xl backdrop-blur-sm border border-blue-700" data-id="element-84">
              <Check className="w-8 h-8 text-green-400 mx-auto mb-2" data-id="element-85" />
              <p className="font-bold" data-id="element-86">Todo listo</p>
            </div>
            <div className="bg-blue-800/50 p-4 rounded-xl backdrop-blur-sm border border-blue-700" data-id="element-87">
              <Check className="w-8 h-8 text-green-400 mx-auto mb-2" data-id="element-88" />
              <p className="font-bold" data-id="element-89">Todo probado</p>
            </div>
            <div className="bg-blue-800/50 p-4 rounded-xl backdrop-blur-sm border border-blue-700" data-id="element-90">
              <Check className="w-8 h-8 text-green-400 mx-auto mb-2" data-id="element-91" />
              <p className="font-bold" data-id="element-92">Todo ordenado</p>
            </div>
            <div className="bg-blue-800/50 p-4 rounded-xl backdrop-blur-sm border border-blue-700" data-id="element-93">
              <Check className="w-8 h-8 text-green-400 mx-auto mb-2" data-id="element-94" />
              <p className="font-bold" data-id="element-95">Todo usable</p>
            </div>
          </div>

          <CTAButton variant="primary" size="large" data-id="element-96">
            QUIERO ACCESO INMEDIATO
          </CTAButton>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16 px-4 bg-white" data-id="element-97">
        <div className="max-w-5xl mx-auto" data-id="element-98">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-99">
            ¿Qué incluye?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-100">
            <div data-id="element-101">
              <div className="bg-orange-50 p-6 rounded-2xl mb-8" data-id="element-102">
                <h3 className="text-2xl font-bold text-orange-600 mb-2" data-id="element-103">
                  📚 +90 libros y cuadernos digitales
                </h3>
                <p className="text-gray-600" data-id="element-104">
                  Una biblioteca completa a tu disposición.
                </p>
              </div>

              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-105">
                {['🎼 Partituras listas', '🎶 Cancioneros organizados', '🥁 Juegos rítmicos', '🎨 Música + Arte', '📝 Evaluaciones', '📋 Planillas docentes', '📚 Guías pedagógicas', '📆 Planificaciones anuales'].map((item, idx) => <li key={idx} className="flex items-center text-gray-700" data-id="element-106">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-3" data-id="element-107"></div>
                    {item}
                  </li>)}
              </ul>

              <div className="mt-8 pt-8 border-t border-gray-100" data-id="element-108">
                <h4 className="font-bold text-gray-900 mb-4" data-id="element-109">
                  Para todo el sistema educativo:
                </h4>
                <div className="flex flex-wrap gap-3" data-id="element-110">
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium" data-id="element-111">
                    👶 Maternal y Preescolar
                  </span>
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium" data-id="element-112">
                    👧 Inicial y Primaria
                  </span>
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium" data-id="element-113">
                    🎼 Secundaria 1° a 5°
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 flex items-center justify-center" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/5AHTgg8bxWwbEujLWhwGXz/PROYECTOS_Anuales_(1).png" alt="Contenido del Megapack" className="w-full max-w-md drop-shadow-xl transform hover:scale-105 transition-duration-300" data-id="element-115" />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-116">
        <div className="max-w-6xl mx-auto" data-id="element-117">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-118">
            {/* Student Benefits */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-green-500" data-id="element-119">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-120">
                <Music className="w-6 h-6 mr-2 text-green-500" data-id="element-121" />
                Qué van a lograr tus alumnos
              </h3>
              <ul className="space-y-4" data-id="element-122">
                {features.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-123">
                    <Check className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-124" />
                    <span className="text-gray-700 font-medium" data-id="element-125">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Teacher Benefits */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-blue-500" data-id="element-126">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-127">
                <Star className="w-6 h-6 mr-2 text-blue-500" data-id="element-128" />
                Qué vas a lograr vos
              </h3>
              <ul className="space-y-4" data-id="element-129">
                {teacherBenefits.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-130">
                    <Check className="w-5 h-5 text-blue-500 mr-3 mt-1 flex-shrink-0" data-id="element-131" />
                    <span className="text-gray-700 font-medium" data-id="element-132">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-white" data-id="element-133">
        <div className="max-w-5xl mx-auto" data-id="element-134">
          <div className="text-center mb-12" data-id="element-135">
            <span className="bg-red-100 text-red-600 font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-136">
              Oferta Especial
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-4" data-id="element-137">
              🎁 BONOS EXCLUSIVOS (GRATIS HOY)
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-138">
            {/* Bonus 1 */}
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-139">
              <div className="aspect-square bg-gray-200 flex items-center justify-center overflow-hidden" data-id="element-140">
                <img src="https://cdn.magicpatterns.com/uploads/qHr8PnRnn46RR9s6nhwEnS/11.png" alt="Bono 1" className="w-full h-full object-cover" data-id="element-141" />
              </div>
              <div className="p-4" data-id="element-142">
                <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-143">
                  🎁 Bono 1 – Partituras del Mundo
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-144">
                  Canciones multiculturales + material internacional listo para
                  usar.
                </p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-145">
              <div className="aspect-square bg-gray-200 flex items-center justify-center overflow-hidden" data-id="element-146">
                <img src="https://cdn.magicpatterns.com/uploads/aWBhVTfSsEBDK6VW5F1K65/12.png" alt="Bono 2" className="w-full h-full object-cover" data-id="element-147" />
              </div>
              <div className="p-4" data-id="element-148">
                <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-149">
                  🎁 Bono 2 – Música Infantil & Bebés
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-150">
                  Canciones, juegos, recursos visuales y actividades para los
                  más pequeños.
                </p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-151">
              <div className="aspect-square bg-gray-200 flex items-center justify-center overflow-hidden" data-id="element-152">
                <img src="https://cdn.magicpatterns.com/uploads/xfjiTjFUdKJDuecrwA9eiN/13.png" alt="Bono 3" className="w-full h-full object-cover" data-id="element-153" />
              </div>
              <div className="p-4" data-id="element-154">
                <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-155">
                  🎁 Bono 3 – Música + Arte + Teatro
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-156">
                  Proyectos creativos integrados para actos, muestras y
                  proyectos escolares.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing / Checkout Section */}
      <section id="checkout" className="py-20 px-4 bg-gradient-to-b from-blue-900 to-blue-800 text-white" data-id="element-157">
        <div className="max-w-3xl mx-auto text-center" data-id="element-158">
          <div className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-159">
            <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold px-8 py-1 transform rotate-45 translate-x-8 translate-y-4" data-id="element-160">
              -70% OFF
            </div>

            <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-161">
              Acceso Completo de Por Vida
            </h2>
            <p className="text-gray-500 mb-8" data-id="element-162">
              Todo el material + Todos los bonos
            </p>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-163">
              <span className="text-gray-400 text-xl md:text-2xl line-through decoration-red-500 decoration-2 mb-2" data-id="element-164">
                Antes $49.99 USD
              </span>
              <div className="flex flex-col items-center" data-id="element-165">
                <span className="text-5xl md:text-6xl font-extrabold text-orange-500" data-id="element-166">
                  $13.99
                </span>
                <span className="text-lg font-bold text-gray-700 uppercase tracking-wide" data-id="element-167">
                  USD
                </span>
                <span className="text-sm text-gray-500 mt-2" data-id="element-168">
                  *Pagarás en la moneda de tu país
                </span>
              </div>
            </div>

            <div className="mb-8 space-y-3" data-id="element-169">
              <div className="flex items-center justify-center text-gray-700" data-id="element-170">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-171" />
                <span data-id="element-172">Acceso inmediato</span>
              </div>
              <div className="flex items-center justify-center text-gray-700" data-id="element-173">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-174" />
                <span data-id="element-175">Descarga ilimitada</span>
              </div>
              <div className="flex items-center justify-center text-gray-700" data-id="element-176">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-177" />
                <span data-id="element-178">Garantía de 7 días</span>
              </div>
            </div>

            <a href="https://checkout1.edulabs.online/cart/42437831852130:1" className="block w-full bg-orange-500 hover:bg-orange-600 text-white font-bold text-xl md:text-2xl py-5 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 border-b-4 border-orange-700 active:border-b-0 active:translate-y-0 mb-4" data-id="element-179">
              SI, QUIERO EL MEGAPACK MÚSICA LISTA™
            </a>

            <div className="flex items-center justify-center gap-2 text-xs text-gray-400 mt-4" data-id="element-180">
              <Shield className="w-3 h-3" data-id="element-181" />
              <span data-id="element-182">Pago 100% seguro y encriptado</span>
            </div>

            <div className="mt-6 flex justify-center gap-2 opacity-50 grayscale" data-id="element-183">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png" alt="Visa" className="h-4" data-id="element-184" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1280px-Mastercard-logo.svg.png" alt="Mastercard" className="h-4" data-id="element-185" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/2560px-PayPal.svg.png" alt="PayPal" className="h-4" data-id="element-186" />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-187">
        <div className="max-w-6xl mx-auto" data-id="element-188">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-189">
            Lo que dicen otros docentes
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-190">
            <TestimonialCard name="Laura Fernández" role="Profesora de Música" location="Buenos Aires, Argentina" quote="Me devolvió el control de mi año docente. Ya no paso los domingos planificando." imageInitials="LF" data-id="element-191" />
            <TestimonialCard name="Carlos Méndez" role="Docente de Primaria" location="Santiago, Chile" quote="Nunca tuve un material tan completo. Mis alumnos están fascinados con las nuevas actividades." imageInitials="CM" data-id="element-192" />
            <TestimonialCard name="Ana García" role="Maestra de Inicial" location="Madrid, España" quote="Mis clases cambiaron por completo. El material es súper fácil de adaptar y usar." imageInitials="AG" data-id="element-193" />
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-16 px-4 bg-white" data-id="element-194">
        <div className="max-w-3xl mx-auto text-center" data-id="element-195">
          <div className="inline-block p-4 rounded-full bg-blue-50 mb-6" data-id="element-196">
            <Shield className="w-12 h-12 text-blue-600" data-id="element-197" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-198">
            Garantía sin vueltas
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-199">
            Tenés 7 días para probarlo. Si no te sirve → te devolvemos el 100%.
          </p>
          <p className="text-gray-500 text-sm max-w-lg mx-auto" data-id="element-200">
            Estamos tan seguros de la calidad de nuestro material que asumimos
            todo el riesgo. Tu satisfacción es nuestra prioridad.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-201">
        <div className="max-w-3xl mx-auto" data-id="element-202">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-203">
            ❓ PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-6" data-id="element-204">
            {faqs.map((faq, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm" data-id="element-205">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-206">
                  {faq.question}
                </h3>
                <p className="text-gray-600" data-id="element-207">{faq.answer}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center" data-id="element-208">
        <div className="max-w-4xl mx-auto" data-id="element-209">
          <p className="mb-4 font-bold text-white" data-id="element-210">MEGAPACK MÚSICA LISTA™</p>
          <p className="text-sm mb-8" data-id="element-211">
            Todos los derechos reservados © {new Date().getFullYear()}
          </p>
          <p className="text-xs text-gray-600" data-id="element-212">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}
function CheckCircleIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-213">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-214" />
    </svg>;
}